export function convertStringToArray(numberInput) {
    // Remove the square brackets
    let str = numberInput.replace(/\[|\]/g, '');

    // Split the string by spaces
    const stringArray = str.split(' ');

    // Convert each element to a number
    const numberArray = stringArray.map(Number);

    return numberArray;
}


export function unixToDate(unixTimestamp) {
    // Convert Unix timestamp to milliseconds
    const date = new Date(unixTimestamp * 1000);

    // Extract the day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    // Return formatted date in dd.mm.yy format
    return `${day}.${month}.${year}`;
}


export function padNumber(number) {
    return number.toString().padStart(2, '0');
}

export async function getCurrentDraw(gamecode) {

    try {
        const response = await window.apiClient.get(`/api/v1/players/lottery/${gamecode}/draws/current`);
        if (response.status === 200) {
            return response;
            // Handle the successful response
        }
    // console.log(response.data);
    // console.log(response.status);
    // console.log(response.statusText);
    // console.log(response.headers);
    // console.log(response.config);
    } catch (error) {
        // Handle the error (401, 404, etc.)
        if (error.response) {
            // The server responded with a status code outside 2xx range
            if (error.response.status === 401) {
                console.log('Unauthorized, redirecting to login...');
                // Redirect to login, or handle 401 specific logic
            } else {
                console.log('Error:', error.response.status, error.response.data);
                // Handle other errors (404, 500, etc.)
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.error('No response received:', error.request);
        } else {
            // Something happened in setting up the request
            console.error('Error setting up request:', error.message);
        }
        return error.response;
    }
   
}  


export async function getPastDraws(gamecode) {

    try {
        const response = await window.apiClient.get(`/api/v1/lottery/${gamecode}/draws?page_size=1000`);
        if (response.status === 200) {
            return response;
            // Handle the successful response
        }
    } catch (error) {
        // Handle the error (401, 404, etc.)
        if (error.response) {
            // The server responded with a status code outside 2xx range
            if (error.response.status === 401) {
                console.log('Unauthorized, redirecting to login...');
                // Redirect to login, or handle 401 specific logic
            } else {
                console.log('Error:', error.response.status, error.response.data);
                // Handle other errors (404, 500, etc.)
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.error('No response received:', error.request);
        } else {
            // Something happened in setting up the request
            console.error('Error setting up request:', error.message);
        }
        return error.response;
    }
   
}  


export async function getDrawByID(gamecode, drawid) {

    try {
        const response = await window.apiClient.get(`/api/v1/players/lottery/${gamecode}/draws/${drawid}`);
        if (response.status === 200) {
            return response;
            // Handle the successful response
        }
    } catch (error) {
        // Handle the error (401, 404, etc.)
        if (error.response) {
            // The server responded with a status code outside 2xx range
            if (error.response.status === 401) {
                console.log('Unauthorized, redirecting to login...');
                // Redirect to login, or handle 401 specific logic
            } else {
                console.log('Error:', error.response.status, error.response.data);
                // Handle other errors (404, 500, etc.)
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.error('No response received:', error.request);
        } else {
            // Something happened in setting up the request
            console.error('Error setting up request:', error.message);
        }
        return error.response;
    }
   
}  


export async function buyTickets(ticketList, draw_id, gamecode) {
    const tickets = ticketList.map(item => {
        return {
            numbers: item.selectedNumbers,   // Map 'selectedNumbers' to 'numbers'
            amount: parseFloat(item.totalAmount)  // Map 'totalAmount' to 'amount' and convert it to a number
        };
    });

    let data = {
        "draw_date_id": draw_id,
        "tickets": tickets
    }

    const response = await window.apiClient.post(`/api/v1/players/lottery/${gamecode}/tickets`, data );

    return response;
}


export function formatNumberWithCommas(numberString) {
    // Convert the string to a number, then format it with commas
    return parseFloat(numberString).toLocaleString( 'en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });
}


export function datetimeToUnixTimestamp(datetimeString) {
    
    if(datetimeString === undefined) {
        return false
    }

   
    // Create a Date object from the datetime string
    const date = new Date(datetimeString);

    // Get the Unix timestamp in seconds by dividing by 1000
    return Math.floor(date.getTime() / 1000);
}

export function stringToNumberArray(str) {
    // Remove the square brackets
    const cleanedStr = str.replace(/[\[\]]/g, "");

    // Split the string by spaces and convert each part to a number
    const numberArray = cleanedStr.split(" ").map(Number);

    return numberArray;
}


// Helper function to calculate factorial
export function factorial(num) {
    if (num === 0 || num === 1) return 1;
    let result = 1;
    for (let i = 2; i <= num; i++) {
      result *= i;
    }
    return result;
  }
  
  // Function to calculate the number of combinations
  export function combinations(n, k) {
    if (k > n) {
        throw new Error("k cannot be greater than n");
    }
    return factorial(n) / (factorial(k) * factorial(n - k));
  }
  

export function updateRegistry (parent, key,data){
    if(key == "my-balance"){

    }
}



  // Function to calculate the chance of selecting k numbers out of n
export function calculateChances(min, max, selected) {
    const totalNumbers = max - min + 1;
  
    // Calculate total combinations
    const totalCombinations = combinations(totalNumbers, selected);
  
    // Calculate the probability (in percentage)
    const probability = (1 / totalCombinations) * 100;
  
    return {
      totalCombinations,
      probability: probability.toFixed(10) + '%', // Rounded to 10 decimal places
    };
}



export function truncateString(str, maxLength = 12, ellipsis = '...') {
    if (str.length > maxLength) {
        return str.substring(0, maxLength) + ellipsis;
    } else {
        return str;
    }
}

export function setLetterSpacing(bitmapText, spacing) {
    let xOffset = 0;
    const text = bitmapText.text;

    // Clear existing text and reposition each character
    bitmapText.text = ''; 
    text.split('').forEach((char) => {
        bitmapText.text += char;
        const charImage = bitmapText.getChildAt(bitmapText.text.length - 1);
        if (charImage) {
            charImage.x = xOffset;
            xOffset += charImage.width + spacing; // Add custom spacing
        }
    });
}


export function applyLetterSpacing(bitmapText, spacing) {
    const text = bitmapText.text.split('');
    let offsetX = 0;

    bitmapText.text = ''; // Clear original text
    text.forEach((char) => {
        const charSprite = bitmapText.add(char);
        charSprite.x = offsetX;
        offsetX += charSprite.width + spacing;
    });
}
  
//   // Function to calculate combinations C(n, k)
// export function combinations(n, k) {
//     if (k > n) {
//       throw new Error("k cannot be greater than n");
//     }
//     return factorial(n) / (factorial(k) * factorial(n - k));
//   }

//   const result = combinations(8, 6);
//   console.log(`Combinations of 6 numbers from 8: ${result}`);
//   // Example usage
//   const result2 = calculateChances(1, 49, 6);
//   console.log(`Total Combinations: ${result2.totalCombinations}`);
//   console.log(`Probability: ${result2.probability}`);